export default __webpack_public_path__ + "static/media/hht1_ep14_minisitcom_02.c977c541.png";